<template>
  <div>
    <ts-label for="fileUploadInput">
      <template v-if="!selectedFileObject">Please upload</template>
      the new configuration file for
      <b>{{ providedData.tenant.CompanyName }}</b>
    </ts-label>
    <!-- eslint-disable vue/no-deprecated-slot-attribute -->
    <ts-file-card
      v-if="selectedFileObject"
      :file-object="
        JSON.stringify({
          name: selectedFileObject?.name ?? '',
          lastModified: selectedFileObject?.lastModified ?? '',
          size: selectedFileObject?.size ?? 0,
          type: selectedFileObject?.type ?? '',
          webkitRelativePath: selectedFileObject.webkitRelativePath ?? '',
        })
      "
      :state="loadingFile ? 'uploading' : 'download'"
      size="medium"
      removable
      @click="cancelConfigUpdate"
      @remove="cancelConfigUpdate"
    >
      <span slot="download-action-text">Cancel</span>
      <span slot="remove-action-text">Cancel</span>
    </ts-file-card>
    <ts-file-uploader-input
      v-else
      id="fileUploadInput"
      :accepted-file-extensions.prop="acceptedFileTypes"
      :size.attr="'medium'"
      @change="onFileChange"
    >
      <span slot="placeholder-text">Select the new configuration file...</span>
      <span slot="button-text">Select</span>
    </ts-file-uploader-input>
    <!-- eslint-enable vue/no-deprecated-slot-attribute -->
  </div>
</template>

<script>
import '@tradeshift/elements.file-uploader-input';
import '@tradeshift/elements.file-card';
import '@tradeshift/elements.label';
import '@tradeshift/elements.spinner';
import { notify, readFileContent } from '../../../../utils';

export default {
  inject: ['providedData'],
  emits: ['is-json-file-change', 'update-config-change', 'new-config-change'],
  data() {
    return {
      selectedFileObject: null,
      acceptedFileTypes: ['yaml', 'yml', 'json'],
      loadingFile: false,
    };
  },
  computed: {
    isJsonFile() {
      return !!this.selectedFileObject?.type?.includes('json');
    },
  },
  watch: {
    isJsonFile(newVal) {
      this.$emit('is-json-file-change', newVal);
    },
  },
  methods: {
    onFileChange(e) {
      if (e.detail && e.detail.files && e.detail.files.length > 0) {
        const oldFileTypeWasJson =
          this.selectedFileObject?.type?.includes('json');

        this.selectedFileObject = e.detail.files[0];
        const hasFileTypeChanged = oldFileTypeWasJson !== this.isJsonFile;
        this.readFileContent(hasFileTypeChanged);
      } else {
        console.error('No files found in the event');
      }
    },
    readFileContent(hasFileTypeChanged) {
      this.loadingFile = true;
      readFileContent(this.selectedFileObject)
        .then((data) => {
          const newConfig = this.isJsonFile ? JSON.parse(data) : data;
          this.$emit('new-config-change', { newConfig, hasFileTypeChanged });
        })
        .catch(() => notify.fail('Could not read the selected file!'))
        .finally(() => {
          this.loadingFile = false;
        });
    },
    cancelConfigUpdate() {
      this.selectedFileObject = null;
      this.$emit('new-config-change', {
        newConfig: null,
        hasFileTypeChanged: false,
      });
    },
  },
};
</script>
